<template>
  <div class="ad-list-page">
    <div class="ad-search-container">
      <ad-searchbar :adSearchModelProp="{ ...adSearchModel }" :full-size="true"
        @submit="onAdSearchSubmit"></ad-searchbar>
    </div>
    <div class="ad-list" v-if="adsFound">
      <ad-preview-card v-for="ad, i in ads" :key="i" :ad="ad"></ad-preview-card>
    </div>
    <div class="ad-list-error" v-else>0 résultat trouvé avec cette recherche</div>
    <div class="ad-list-pagination">
      <p>{{ adsNumber }} annonces trouvées </p>
      <b-pagination size="md" :total-rows="adsNumber" v-model="currentPage" :per-page="adsLimit" first-number
        last-number next-class="ad-list-pagination-btn" prev-class="ad-list-pagination-btn">
        <template #page="{ page, active }">
          <p v-if="active" class="openSans-bold">{{ page }}</p>
          <p v-else class="openSans-light">{{ page }}</p>
        </template>
      </b-pagination>
    </div>
  </div>
</template>

<script>
import DataApi from 'fm-data-api'
import AdSearchbar from './AdSearchbar.vue'
import AdPreviewCard from './AdPreviewCard.vue'
import Vue from 'vue'
import Element from 'element-ui'

Vue.use(Element)

export default {
  name: 'AdList',
  components: {
    AdSearchbar,
    AdPreviewCard
  },
  data() {
    return {
      ads: {},
      adsFound: true,
      currentPage: 1,
      adsNumber: 0,
      adsLimit: 9,
      adSearchModel: {
        type: null,
        roomCount: null,
        surface: null,
        coordinates: null,
        distance: '20',
        budget: null
      }
    }
  },
  methods: {
    async getAds(adSearchModel) {
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      this.dataApi = new DataApi(options)

      let query = this.buildGetAdQuery(adSearchModel)

      if (adSearchModel.coordinates !== null && adSearchModel.coordinates) {
        let coordinatesArray = adSearchModel.coordinates.split('@')
        await this.dataApi.setGlobalFields('', {
          "ANN__Annonce::g_latLieu": coordinatesArray[0],
          "ANN__Annonce::g_lonLieu": coordinatesArray[1],
          "ANN__Annonce::g_rayonLieu": adSearchModel.distance
        })
        if (query && query.length) {
          query[0].fields.push({
            fieldname: 'd_dansLaZoneDeRecherche',
            fieldvalue: 1
          })
        } else {
          query = []
          query.push({
            fields: [{
              fieldname: 'd_dansLaZoneDeRecherche',
              fieldvalue: 1
            }]
          })
        }
      }

      const sort = [{
        fieldName: 'd_dateAnnonce',
        sortOrder: 'descend'
      }]
      if (!query.length) {
        this.dataApi.getRecords('W_Annonce', sort, this.offset, '9', [], [], true)
          .then((res) => {
            this.insertAds(res)
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        this.dataApi.findRecords('W_Annonce', query, sort, this.offset, '9', [], [], true)
          .then((res) => {
            this.insertAds(res)
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    insertAds(ads) {
      if (!('dataInfo' in ads && 'foundCount' in ads.dataInfo)) {
        this.adsFound = false
        console.log('error: ' + ads)
        return
      }
      this.adsNumber = ads.dataInfo && ads.dataInfo.foundCount
      if (this.adsNumber === 0) {
        this.adsFound = false
        return
      }
      const adsToInsert = {}
      for (let ad of ads.data) {
        ad.fieldData.recordId = ad.recordId
        adsToInsert[ad.recordId] = ad.fieldData
      }
      this.adsFound = true
      this.ads = adsToInsert
    },
    onAdSearchSubmit(adSearchModel) {
      this.getAds(adSearchModel)
    },
    buildGetAdQuery(adSearchModel) {
      let fields = []
      let simpleFields = {}
      if (adSearchModel.surface != null) { simpleFields.d_surface = adSearchModel.surface.join('...') }
      if (adSearchModel.budget != null) { simpleFields.d_prix = adSearchModel.budget.join('...') }
      if (adSearchModel.type && adSearchModel.type.length > 0) {
        for (let type of adSearchModel.type) {
          if (adSearchModel.roomCount && adSearchModel.roomCount.length > 0) {
            for (let room of adSearchModel.roomCount) {
              fields.push({
                d_nbrPieces: room,
                d_type: type,
                ...simpleFields
              })
            }
          } else {
            fields.push({
              d_type: type,
              ...simpleFields
            })
          }
        }
      } else if (adSearchModel.roomCount && adSearchModel.roomCount > 0) {
        for (let room of adSearchModel.roomCount) {
          fields.push({
            d_nbrPieces: room,
            ...simpleFields
          })
        }
      } else if (Object.keys(simpleFields).length > 0) {
        fields.push({ ...simpleFields })
      }

      if (fields.length === 0) {
        return false
      } else {
        let query = []
        for (let field of fields) {
          let arrayField = []
          for (let key in field) {
            arrayField.push({
              fieldname: key,
              fieldvalue: field[key]
            })
          }
          query.push({
            fields: arrayField
          })
        }
        return query
      }
    }
  },
  computed: {
    offset: function () {
      const offset = ((this.currentPage - 1) * this.adsLimit).toString()
      return offset
    }
  },
  watch: {
    currentPage: function (val, oldVal) {
      this.getAds(this.adSearchModel)
    }
  },
  async beforeMount() {
    if (this.$route.params.adSearchModel) {
      this.adSearchModel = this.$route.params.adSearchModel
    }
    this.getAds(this.adSearchModel)
  }
}
</script>

<style lang="scss">
.ad-list-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 40px;
  max-width: var(--max-width);
  width: 100%;

  .ad-search-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ad-list {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin: 32px 0 48px 0;

    .ad-preview-card {
      margin: 17px;
    }
  }

  .ad-list-error {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
  }

  .ad-list-pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: white;
    border-radius: 4px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    height: 80px;
    font-size: var(--font-size-normal);
    font-weight: 600;
    padding: 32px;

    ul {
      align-items: center;
    }
    ul,
    p {
      margin: 0;
    }

    .page-item {
      margin: 16px;
    }

    .page-item.active .page-link {
      background-color: white;
      color: var(--color-primary);
    }

    .page-link {
      border: none;
      color: black;
      padding: 0;

      &:focus {
        box-shadow: none;
      }
    }

    .ad-list-pagination-btn {

      span,
      button {
        background-color: var(--color-primary);
        color: white;
        width: 60px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 35px;
        border-radius: 5px;
        padding-bottom: 0.5rem;
      }
    }
  }
}

@media (max-width: 500px) {
  .ad-list-page {
    margin: 16px;
  }
}
</style>